import {Injectable, Inject} from '@angular/core';
import {UserReflexiveModel} from './user.reflexive.model';
import {RestService, RestYiiFilterService, RestYiiSort, RestYiiPagination, RestSimpleResponseParser} from 'gelios-ng-admin-components';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class UserListService extends RestService <UserReflexiveModel> {

  public get url(): string {
    return this.environmentApiBasepoint + 'user';
  }

  constructor(
    protected http: HttpClient,
    protected _filter: RestYiiFilterService,
    protected _sort: RestYiiSort,
    protected _pagination: RestYiiPagination,
    protected _parser: RestSimpleResponseParser,
    @Inject('ENVIRONMENT_VERSION') protected environmentVersion: string,
    @Inject('ENVIRONMENT_API_BASEPOINT') protected environmentApiBasepoint: string
  ) {
    super(http, _filter, _sort, _pagination, _parser, environmentVersion, environmentApiBasepoint);
    // this.fields = [
    //   'id',
    //   'login',
    //   'password_input1',
    //   'password_input2',
    //   'email',
    //   'role',
    //   'admin_id',
    //   'admin.login',
    //   'integrator_id',
    //   'integrator.login',
    //   'subscription_fee',
    //   'unit_cost',
    //   'unit_billing_type',
    //   'acquirer_name',
    //   'organization_name',
    //   'number_days_in_minus',
    //   'days',
    //   'balance',
    //   'insurance_balance',
    //   'sims_balance',
    //   'sim_manager_id',
    //   'acquirer.name',
    //   'sims_balance_flash_call',
    //   'blockingStatus',
    //   'isBlocked',
    //   'isBlockedFrom',
    //   'blockedUserId',
    // ].join(',');
    this.expand = [
      'combinedRoleId',
      'combinedRoleName',
      'admin',
      'integrator',
      'acquirer',
      'project_custom_name',
      'projectCountryName',
      'regionNames',
      'billingVer202212CurrencyAbbreviation',
      'userBillingAcquirer',
      'insuranceProvider',
      'billingPaymentType',
      'billingCalculationMethod',
      'billingCurrencyCode',
      'hasPendingPostponedPricePlanConfiguration',
      'calculatedStatus',
      'canLoginAs',
      'business_logic_custom_names',
      'simsBalanceCurrencyAbbreviation'
    ].join(',');
    this._filter.searchModelName = 'UserSearch';
  }

}
